<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">智慧医院在线问诊系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          在数字化医疗蓬勃发展的时代，互联网医院在线问诊应运而生。它并非简单地将线下医疗流程 “搬” 到线上，而是以微信生态为载体，深度融合人工智能、大数据、物联网等前沿技术，为患者、医师、药师及监管部门搭建起一个全流程、多角色、智能化的医疗服务与管理平台。
        </p>
        <p class="content-paragraph">
          系统覆盖患者端、医师端、药师端与监管对接：患者端支持自动绑档、人脸建档、问诊挂号、病情描述、在线问诊与诊后查询；医师端提供待接诊审核、全程病历查看、图文音视频问诊、电子签名处方；药师端完成审方与签名；同时对接监管平台、院内基础系统、CA 签名，保障线上诊疗合规可追溯。这一系统从患者就医需求出发，重构医疗服务链路，打破传统医疗 “时空受限、流程繁琐、信息孤岛” 的壁垒。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">患者端</h3>
            <ul class="capability-list"><li>自动绑档</li><li>人脸建档</li><li>问诊挂号</li><li>搜索医生</li><li>科室列表</li><li>医师排班</li><li>病情描述</li><li>在线问诊</li><li>自助缴费</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">医师端</h3>
            <ul class="capability-list"><li>待接诊查看</li><li>历史病历查看</li><li>拒诊/接诊审核</li><li>图文音视频</li><li>编辑诊断</li><li>电子签名</li><li>处方提交审核</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">药师端与监管</h3>
            <ul class="capability-list"><li>药师审方</li><li>审核记录查看</li><li>医师CA签名</li><li>药师CA签名</li><li>监管平台对接</li><li>安全等保</li><li>院内系统对接</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wz-patient.svg"
              alt="海南华德科技有限公司 智慧医院在线问诊系统 - 患者端 · 问诊挂号与建档"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>患者端 · 问诊挂号与建档
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wz-chat.svg"
              alt="海南华德科技有限公司 智慧医院在线问诊系统 - 在线问诊 · 图文音视频沟通"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>在线问诊 · 图文音视频沟通
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wz-doctor.svg"
              alt="海南华德科技有限公司 智慧医院在线问诊系统 - 医师端接诊工作台"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>医师端接诊工作台
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wz-audit.svg"
              alt="海南华德科技有限公司 智慧医院在线问诊系统 - 药师审方与监管平台对接"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>药师审方与监管平台对接
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/software4.vue